import { ReactNode } from "react";

export type UIMenuItemProps = {
  value: string | number;
  children: ReactNode;
};

export const UIMenuItem = (_props: UIMenuItemProps) => null;
